// One place decides what colour a side is drawn in.
//
// Green/red is a claim: the yes side is the good answer, the no side is the bad
// one. That is true of Yes/No, Over/Under, Up/Down — and false of FURIA vs
// Aurora Gaming, where index 0 and index 1 are Polymarket's arbitrary ordering.
// Named pairs are drawn in the theme's own two-side palette instead, which
// separates the sides without ranking them.

import type { Theme } from '@mui/material/styles';
import type { SideLabels } from './boardOutcomeLabels';

/** The first outcome's colour: the same blue the selected probability bar uses. */
export const outcomeColorA = (theme: Theme) => theme.palette.primary.main;
/** The second outcome's colour: the theme's amber, unrelated to success/error. */
export const outcomeColorB = (theme: Theme) => theme.palette.warning.main;

export interface SideColorOptions {
    /** Grey the sideless case, for cells that are not the row's focus. */
    muted?: boolean;
}

export function sideColor(
    labels: SideLabels,
    side: 'YES' | 'NO' | null | undefined,
    theme: Theme,
    opts: SideColorOptions = {}
): string {
    if (side !== 'YES' && side !== 'NO') {
        return opts.muted ? theme.palette.text.disabled : theme.palette.text.primary;
    }
    if (labels.namedPair) return side === 'YES' ? outcomeColorA(theme) : outcomeColorB(theme);
    return side === 'YES' ? theme.palette.success.main : theme.palette.error.main;
}
